"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Layout = require("./Layout.style");

var _logoMobile = _interopRequireDefault(require("../assets/images/logo/logo-mobile.svg"));

var Footer = function Footer() {
  return /*#__PURE__*/_react.default.createElement(_Layout.FooterWrapper, null, /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, "\xA9 2022 MDPortals Inc."), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("img", {
    src: _logoMobile.default,
    alt: "Reveleer Logo",
    width: "30",
    height: "30"
  }))));
};

var _default = Footer;
exports.default = _default;